import { useTranslation } from 'react-i18next'
import { AlertTriangle } from 'lucide-react'

/** Avviso per le variabili senza valore: mai una stringa vuota silenziosa (#251). */
export function MissingVariablesNotice({ variables }: { variables: string[] }) {
  const { t } = useTranslation('common')
  if (variables.length === 0) return null
  return (
    <div
      role="status"
      className="rounded-md border border-amber-200 bg-amber-50 dark:border-amber-800 dark:bg-amber-950 p-2 flex items-center gap-2"
    >
      <AlertTriangle className="h-4 w-4 text-amber-700 dark:text-amber-400 shrink-0" />
      <p className="text-xs text-amber-700 dark:text-amber-400">
        {t('contactPreview.missingVariables', {
          vars: variables.map((v) => `{{${v}}}`).join(', '),
        })}
      </p>
    </div>
  )
}
